// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import BlogListState from "@store/Framework/Store/Store/Pages/BlogList/BlogListState";
import {
    BlogListFiltersModel,
    GetBlogApiParameter,
} from "@store/Framework/Store/Store/Pages/BlogList/Handlers/GetBlogList";
import { Draft } from "immer";

const initialState: BlogListState = {
    getBlogPagesParameters: {
        sortBy: "Newest",
        isArchived: false,
    },
};

const actions = {
    "Store/Pages/BlogList/UpdateLoadParameter": (
        draft: Draft<BlogListState>,
        { parameter }: { parameter: GetBlogApiParameter },
    ) => {
        draft.getBlogPagesParameters = parameter;
    },
    "Store/Pages/BlogList/GetFiltersComplete": (
        draft: Draft<BlogListState>,
        { parameter }: { parameter: BlogListFiltersModel },
    ) => {
        draft.blogListFilters = parameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreBlogListActions = Parameters<typeof reducer>[1];
export default reducer;
